import cn from 'classnames';
import { motion } from 'framer-motion';

import { STAMP_CARD_WIDGET_STAMP_EARNED } from '../../../constants';

import {
  JUST_STAMPED_CASCADE_STEP_SECONDS,
  STAMP_ENTER_SECONDS,
  STAMP_JUST_EARNED_EXTRA_DELAY_SECONDS,
  STAMP_STAGGER_BASE_DELAY_SECONDS,
  STAMP_STAGGER_STEP_SECONDS,
  stampVariants,
} from './stampAnimation';
import styles from './StampCardStampsRow.module.scss';

interface StampCardStampIconProps {
  staggerIndex: number;
  isEarned: boolean;
  emptyStampAssetUrl?: string | null;
  filledStampAssetUrl?: string | null;
  locked?: boolean;
  lockedStampAssetUrl?: string | null;
  isJustStamped?: boolean;
  justStampedOrder?: number;
  isJustUnlocked?: boolean;
  animated: boolean;
  animateState: 'hidden' | 'visible' | 'exit';
  dataTestId?: string;
}

export function StampCardStampIcon(props: StampCardStampIconProps) {
  const {
    staggerIndex,
    isEarned,
    emptyStampAssetUrl,
    filledStampAssetUrl,
    locked,
    lockedStampAssetUrl,
    isJustStamped,
    justStampedOrder = -1,
    isJustUnlocked,
    animated,
    animateState,
    dataTestId,
  } = props;

  const revealDelaySeconds =
    (animated
      ? STAMP_STAGGER_BASE_DELAY_SECONDS +
        staggerIndex * STAMP_STAGGER_STEP_SECONDS +
        STAMP_ENTER_SECONDS +
        STAMP_JUST_EARNED_EXTRA_DELAY_SECONDS
      : 0) +
    Math.max(justStampedOrder, 0) * JUST_STAMPED_CASCADE_STEP_SECONDS;

  const iconElement = (
    <>
      {emptyStampAssetUrl && <img alt="" className={styles.stampBaseIcon} src={emptyStampAssetUrl} />}
      {isEarned && (
        <img
          alt=""
          className={cn(styles.stampFilledIcon, isJustStamped && styles.stampJustEarnedIcon)}
          src={filledStampAssetUrl || STAMP_CARD_WIDGET_STAMP_EARNED}
          style={isJustStamped ? { animationDelay: `${revealDelaySeconds}s` } : undefined}
        />
      )}
      {(locked || isJustUnlocked) && lockedStampAssetUrl && (
        <img
          alt=""
          className={cn(styles.stampLockedIcon, isJustUnlocked && styles.stampJustUnlockedIcon)}
          src={lockedStampAssetUrl}
        />
      )}
    </>
  );

  if (!animated) {
    return (
      <div className={styles.stamp} data-testid={dataTestId}>
        {iconElement}
      </div>
    );
  }

  return (
    <motion.div
      animate={animateState}
      className={styles.stamp}
      custom={staggerIndex}
      data-testid={dataTestId}
      initial="hidden"
      variants={stampVariants}
    >
      {iconElement}
    </motion.div>
  );
}
